import React from "react";
import { Loader2 } from "lucide-react";

function LogoutTemplate({ children, status = "loading" }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-gray-900 to-[#F26522]/20 p-4">
      <div className="bg-gray-900 rounded-2xl shadow-2xl p-12 text-center max-w-md w-full relative overflow-hidden">
        <div className="absolute -top-10 -right-10 w-44 h-44 rounded-full bg-[#F26522]/20 pointer-events-none" />
        <div className="absolute -bottom-8 -left-8 w-36 h-36 rounded-full bg-[#F26522]/15 pointer-events-none" />
        <div className="relative">
          <img
            src="/LogoLiberty.png"
            alt="Liberty Latin America"
            className="h-16 mx-auto mb-8 brightness-0 invert"
          />
          <Loader2
            className={`w-10 h-10 animate-spin mx-auto mb-4 ${
              status === "error" ? "text-red-400" : "text-[#F26522]"
            }`}
          />
          {children}
        </div>
      </div>
    </div>
  );
}

export default LogoutTemplate;
